import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.6574 0.310504C11.8787 0.229832 12.1213 0.229832 12.3426 0.310504L21.3426 3.59208C21.7373 3.73602 22 4.11139 22 4.53158V14.1047C22 15.6595 21.2987 17.0382 20.3736 18.1842C19.4468 19.3323 18.2372 20.3206 17.0707 21.1195C15.8983 21.9224 14.7323 22.5589 13.8631 22.9937C13.4273 23.2117 13.063 23.3805 12.8059 23.4955C12.7717 23.5109 12.7371 23.5268 12.7023 23.5428C12.4801 23.6451 12.2457 23.7531 12 23.7502C11.7551 23.7531 11.5287 23.6489 11.3011 23.5443C11.2654 23.5279 11.2298 23.5115 11.1941 23.4955C10.937 23.3805 10.5727 23.2117 10.1369 22.9937C9.26766 22.5589 8.10169 21.9224 6.92933 21.1195C5.76277 20.3206 4.55319 19.3323 3.62639 18.1842C2.7013 17.0382 2 15.6595 2 14.1047V4.53158C2 4.11139 2.26268 3.73602 2.65744 3.59208L11.6574 0.310504ZM16.6186 8.21436C17.0526 8.55602 17.1273 9.18476 16.7857 9.61868L11.8127 15.9345C11.6336 16.1619 11.3648 16.3006 11.0756 16.3146C10.7865 16.3287 10.5054 16.2168 10.3051 16.0078L7.27809 12.8499C6.89592 12.4512 6.90931 11.8182 7.30801 11.436C7.70671 11.0539 8.33973 11.0672 8.72191 11.4659L10.953 13.7934L15.2143 8.38141C15.556 7.94749 16.1847 7.8727 16.6186 8.21436Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconCheckmarkShieldFill = forwardRef(Icon);
export default IconCheckmarkShieldFill;
